import React from "react";
import { Typography, Box } from "@mui/material";
import "./CardList.scss";
import { ReactComponent as UpArrow } from "../../assets/CardListIcon/ic-solar_double-alt-arrow-up-bold-duotone.svg";
import { ReactComponent as DownIcon } from "../../assets/CardListIcon/downDecIcon.svg";

const CardList = ({ data, direction = "horizontal" }) => {
  return (
    <Box
      display="flex"
      flexDirection={direction === "horizontal" ? "row" : "column"}
      gap={3}
    >
      {data.map((item, index) => (
        <Box className="cardListBox" key={index}>
          <Box className="cardBox">
            <Box>
              <Typography
                className="title"
                variant="subtitle2"
                color="textSecondary"
              >
                {item.title}
              </Typography>
              <Typography className="priceValue" variant="h4" fontWeight="bold">
                {item.value}
              </Typography>
              <Box display="flex" alignItems="center" gap={0.5} mt={1}>
                {item.isIncrease ? <UpArrow /> : <DownIcon />}
                <Typography className="value">{item.percentage}%</Typography>
                <Typography className="subValue">ultimi 30 giorni</Typography>
              </Box>
            </Box>
            <Box className="iconBox">{item.icons}</Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default CardList;
